const _ = false;
const O = true;

export const TOAD:boolean[][] = [
  [_, _, _, _, _, _],
  [_, _, _, O, _, _],
  [_, O, _, _, O, _],
  [_, O, _, _, O, _],
  [_, _, O, _, _, _],
  [_, _, _, _, _, _],
];

export const GLIDER:boolean[][] = [
  [_, _, _, _, _, _],
  [_, _, O, _, _, _],
  [_, _, _, O, _, _],
  [_, O, O, O, _, _],
  [_, _, _, _, _, _],
  [_, _, _, _, _, _],
];
